module.exports = __webpack_public_path__ + "static/media/slogan-tc.f5e58c7e.png";